module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/rewards/additional-briefing-reward-100.85b18f36.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/rewards/additional-briefing-reward-100.png
// module id = 3768
// module chunks = 11